
const contractInfos = [
  {
    "id": "20c94fc2-0414-48bc-b006-d289e93e8fe4",
    "mondayWorkLoad": 468,
    "tuesdayWorkLoad": 468,
    "wednesdayWorkLoad": 468,
    "thursdayWorkLoad": 468,
    "fridayWorkLoad": 468,
    "saturdayWorkLoad": 0,
    "sundayWorkLoad": 0,
  },
  {
    "id": "e42ecbdc-1e4e-40b3-946b-d35f7339e2d1",
    "mondayWorkLoad": 300,
    "tuesdayWorkLoad": 300,
    "wednesdayWorkLoad": 300,
    "thursdayWorkLoad": 300,
    "fridayWorkLoad": 0,
    "saturdayWorkLoad": 0,
    "sundayWorkLoad": 0,
  },
  {
    "id": "219a20a1-d270-4d66-9ac2-b9b660e2ed5e",
    "mondayWorkLoad": 468,
    "tuesdayWorkLoad": 468,
    "wednesdayWorkLoad": 468,
    "thursdayWorkLoad": 468,
    "fridayWorkLoad": 468,
    "saturdayWorkLoad": 0,
    "sundayWorkLoad": 0,
  },
]

export default contractInfos.map(c => {
  return {
    mondayWorkLoad : "07:48:00",
    tuesdayWorkLoad : "07:48:00",
    wednesdayWorkLoad : "07:48:00",
    thursdayWorkLoad : "07:48:00",
    fridayWorkLoad : "07:48:00",
    saturdayWorkLoad : "00:00:00",
    sundayWorkLoad : "00:00:00",
  }
})
